module.exports = "/_next/static/images/ca3b18966710fcf88ba13fa67dad63e9-hero-lg-1x.jpg.webp";